"use client";
import Image from "next/image";
import React, { useState } from "react";

const tableRows = [
  {
    label: "IMA-Approved CMA Study Materials",
    students: "₹49,000",
    professionals: "₹49,000",
    type: "normal",
  },
  {
    label: "Management Accounting Training Program Fees",
    students: "₹50,000",
    professionals: "₹50,000",
    type: "normal",
  },
  {
    label: "IMA Fees (inclusive of GST)",
    students: "",
    professionals: "",
    type: "ima-header",
  },
  {
    label:
      "IMA Membership Fees (3 Years for Students/ 1 year for Professionals)",
    students: "$173  (₹16,305)",
    professionals: "$348  (₹32,799)",
    type: "normal",
  },
  {
    label: "IMA Entrance Fee",
    students: "$266  (₹25,071)",
    professionals: "$354  (₹33,365)",
    type: "normal",
  },
  {
    label: "IMA Exam (for both parts)",
    students: "$961  (₹90,575)",
    professionals: "$1,286  (₹1,21,206)",
    type: "normal",
  },
  {
    label: "Gross IMA Fees",
    students: "$1,400  (₹1,31,951)",
    professionals: "$1,988  (₹1,87,370)",
    type: "gross",
  },
  {
    label: "IMA bundle discount for Miles (IMA's Diamond Partner)",
    students: "-$534  (-₹50,329)",
    professionals: "-$573  (-₹54,006)",
    type: "discount",
  },
  {
    label: "Net IMA Fees",
    students: "$866  (₹81,621)",
    professionals: "$1,415  (₹1,33,364)",
    type: "net",
  },
];

const gradientBg =
  "linear-gradient(to bottom right, rgba(51,153,255,0.44) 0%, rgba(51,153,255,0.00) 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(51,153,255,0.44) 0%, rgba(51,153,255,0.00) 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(51,153,255,0.44) 0%, rgba(51,153,255,0.00) 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(51,153,255,0.44) 0%, rgba(51,153,255,0.00) 50%) top right / 50% 50% no-repeat, linear-gradient(to bottom right, rgba(51,153,255,0.26) 0%, rgba(51,153,255,0.00) 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(51,153,255,0.26) 0%, rgba(51,153,255,0.00) 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(51,153,255,0.26) 0%, rgba(51,153,255,0.00) 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(51,153,255,0.26) 0%, rgba(51,153,255,0.00) 50%) top right / 50% 50% no-repeat, linear-gradient(180deg, rgba(51,153,255,0.02) 0%, rgba(51,153,255,0.20) 100%), #FFF";

const PricingBox = () => (
  <div
    className="rounded-lg relative overflow-hidden pt-[30px] px-4 pb-4 w-full"
    style={{ background: gradientBg }}
  >
    <div className="absolute top-0 left-0 rounded-tl-lg rounded-tr-none rounded-br-[17.351px] rounded-bl-none bg-[#ba1a1a] w-[56.287px] h-[34.703px] flex items-center justify-center gap-0.5 px-1.5 py-1">
      <span className="text-white text-[25.392px] font-bold leading-normal tracking-[-0.186px]">
        50
      </span>
      <span className="text-white text-[8.464px] font-bold leading-normal tracking-[-0.186px] text-left">
        %<br />
        OFF
      </span>
    </div>
    <div className="flex items-stretch gap-4 w-full max-md:flex-col">
      <div className="flex-1 rounded-lg bg-[#f9fafb] p-3 flex flex-col items-center gap-1">
        <p className="text-[#101828] text-sm font-medium leading-[27px] tracking-[-0.439px] text-center">
          Discounted CAIRA Fees
        </p>
        <p className="text-[#3399ff] text-lg font-bold leading-7 tracking-[-0.439px] text-center">
          ₹50,000
        </p>
      </div>
      <div className="flex-1 rounded-lg bg-[#f9fafb] p-3 flex flex-col items-center gap-1">
        <p className="text-[#101828] text-sm font-medium leading-[27px] tracking-[-0.439px] text-center">
          Bundle Fee for CMA + CAIRA
        </p>
        <p className="text-[#3399ff] text-lg font-bold leading-7 tracking-[-0.439px] text-center">
          ₹1,49,000
        </p>
      </div>
    </div>
  </div>
);

const PayBadge = () => (
  <div className="flex flex-col items-center gap-2">
    <Image
      src="https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cma-new/pay-amount-badge.webp"
      alt="Pay ₹9,083/month"
      width={260}
      height={259}
      className="w-[260px] h-[259px] object-contain"
    />
    <p className="text-black text-[10px] font-medium leading-normal text-right max-md:text-center">
      *12-month EMI (zero interest, zero processing fees)
      <br />
      *Upfront Payment ₹30,000
    </p>
  </div>
);

const FeesSection = () => {
  const [activeTab, setActiveTab] = useState<"students" | "professionals">(
    "students",
  );

  const getRowBgClass = (type: string) => {
    if (type === "gross") return "bg-[rgba(212,219,226,0.2)]";
    if (type === "net") return "bg-[rgba(0,96,171,0.05)]";
    return "";
  };

  const getColLabelColorClass = (type: string) => {
    if (type === "discount") return "!text-[#ba1a1a]";
    if (type === "net") return "!text-[#3399ff]";
    return "";
  };

  const getColValColorClass = (type: string) => {
    let cls = "";
    if (type === "discount") cls += " !text-[#ba1a1a]";
    if (type === "net")
      cls += " !text-[#3399ff] !text-base !font-semibold !leading-5";
    if (type === "gross") cls += " !font-semibold";
    return cls;
  };

  return (
    <section className="py-[60px] bg-no-repeat bg-cover bg-center bg-[url('https://ik.imagekit.io/mileseducation/miles_website/landing-pages/cma-new/fees-bg-desk.webp')] max-md:p-4 max-md:bg-none max-md:bg-[#f3f3f3]">
      <div className="main_container flex flex-col items-center max-md:bg-white max-md:rounded-2xl max-md:px-4 max-md:py-6 max-md:w-full">
        <h2 className="text-center text-[32px] font-bold text-[#1d1d1d] m-0 mb-8 tracking-[-0.03em] max-sm:text-2xl max-sm:mb-4">
          CMA Course <span className="text-[#1a75ef]">Fee Structure</span>
        </h2>
        <p className="text-[#555] text-sm font-normal text-center -mt-5 mb-8 max-md:mt-2 max-md:mb-5">
          {" "}
          Breakdown of typical CMA course and Exam Fee
        </p>

        {/* ── DESKTOP ── */}
        <div className="flex items-start justify-center gap-6 w-full max-lg:flex-col max-lg:items-center max-md:hidden">
          {/* Left: table */}
          <div className="flex-none w-[552px] h-[572px] max-lg:w-full max-lg:h-auto">
            <div className="flex flex-col items-start rounded-lg border border-[#c0c7d5] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] overflow-hidden w-full h-full">
              <div className="flex w-full border-b border-[#c0c7d5] bg-[#eef4fc] flex-1 items-center">
                <div className="flex-[1.8] px-3 py-2.5 text-[#161c22] text-sm font-medium leading-normal" />
                <div className="flex-1 px-3 py-2.5 text-[#161c22] text-sm font-semibold leading-[21px] text-center">
                  Students
                </div>
                <div className="flex-1 px-3 py-2.5 text-[#161c22] text-sm font-semibold leading-[21px] text-center">
                  Professionals
                </div>
              </div>
              {tableRows.map((row, i) => {
                if (row.type === "ima-header") {
                  return (
                    <div
                      key={i}
                      className="flex w-full border-t border-[#c0c7d5] bg-[#eef4fc] items-center first:border-t-0"
                    >
                      <span className="px-3 text-[#161c22] text-sm font-bold leading-normal">
                        {row.label}
                      </span>
                    </div>
                  );
                }
                return (
                  <div
                    key={i}
                    className={`flex w-full border-t border-[#c0c7d5] flex-1 items-center first:border-t-0 ${getRowBgClass(row.type)}`}
                  >
                    <div
                      className={`flex-[1.8] px-3 py-2.5 text-[#161c22] text-sm font-medium leading-normal ${getColLabelColorClass(row.type)} ${row.type === "gross" ? "font-semibold" : ""}`}
                    >
                      {row.label}
                    </div>
                    <div
                      className={`flex-1 px-3 py-2.5 text-[#161c22] text-sm font-medium leading-normal text-center ${getColValColorClass(row.type)}`}
                    >
                      {row.students}
                    </div>
                    <div
                      className={`flex-1 px-3 py-2.5 text-[#161c22] text-sm font-medium leading-normal text-center ${getColValColorClass(row.type)}`}
                    >
                      {row.professionals}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right: pricing + pay */}
          <div className="flex flex-col items-center gap-4 flex-none w-[492px] h-[474px] max-lg:w-full max-lg:h-auto">
            <PricingBox />
            <PayBadge />
          </div>
        </div>

        {/* ── MOBILE ── */}
        <div className="hidden max-md:flex max-md:flex-col max-md:items-center max-md:gap-4 max-md:w-[330px] max-md:max-w-full">
          <div className="rounded-2xl bg-[#f3f3f3] flex p-1 items-center w-full mb-4">
            <button
              className={`flex-1 rounded-2xl border-0 text-sm leading-normal py-2 cursor-pointer text-center ${
                activeTab === "students"
                  ? "bg-[radial-gradient(1474.29%_161.47%_at_113.4%_210.95%,#b9dcff_0%,#3a9cff_100%)] text-white font-bold"
                  : "bg-transparent text-[#777] font-medium"
              }`}
              onClick={() => setActiveTab("students")}
            >
              Students
            </button>
            <button
              className={`flex-1 rounded-2xl border-0 text-sm leading-normal py-2 cursor-pointer text-center ${
                activeTab === "professionals"
                  ? "bg-[radial-gradient(1474.29%_161.47%_at_113.4%_210.95%,#b9dcff_0%,#3a9cff_100%)] text-white font-bold"
                  : "bg-transparent text-[#777] font-medium"
              }`}
              onClick={() => setActiveTab("professionals")}
            >
              Professionals
            </button>
          </div>

          <div className="flex flex-col items-start rounded-lg border border-[#c0c7d5] bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] overflow-hidden w-full h-[510px] max-w-full">
            {tableRows.map((row, i) => {
              if (row.type === "ima-header") {
                return (
                  <div
                    key={i}
                    className="flex w-full border-t border-[#c0c7d5] bg-[#eef4fc] items-center first:border-t-0"
                  >
                    <span className="px-3 text-[#161c22] text-sm font-bold leading-normal">
                      {row.label}
                    </span>
                  </div>
                );
              }
              const val =
                activeTab === "students" ? row.students : row.professionals;
              return (
                <div
                  key={i}
                  className={`flex w-full border-t border-[#c0c7d5] flex-1 items-center first:border-t-0 ${getRowBgClass(row.type)}`}
                >
                  <div
                    className={`flex-[1.8] px-3 py-2.5 !text-sm font-medium leading-normal text-[#161c22] ${getColLabelColorClass(row.type)}`}
                  >
                    {row.label}
                  </div>
                  <div
                    className={`flex-1 px-3 py-2.5 !text-sm font-medium leading-normal text-center text-[#161c22] ${getColValColorClass(row.type)}`}
                  >
                    {val}
                  </div>
                </div>
              );
            })}
          </div>

          <PricingBox />
          <PayBadge />
        </div>
      </div>
    </section>
  );
};

export default FeesSection;
